import Vue from 'vue'
import VueRouter from 'vue-router'
import configuration from '@/config'
// [URGENT]: Maintenance
import fetchProfileMiddleware from '@/middlewares/fetchProfile.middleware'
import fetchSystemConfigMiddleware from '@/middlewares/fetchSystemConfig.middleware'
import liffMiddleware from '@/middlewares/liff.middleware'
// import fetchProfileMiddleware from '@/middlewares/fetchProfile.maintenance.middleware'
// import liffMiddleware from '@/middlewares/liff.maintenance.middleware'
// ---------------------
import affiliateMiddleware from '@/middlewares/affiliate.middleware'
import fetchCustomerTypesMiddleware from '@/middlewares/fetchCustomerTypes.middleware'
import fetchNewLineOaOrdersMiddleware from '@/middlewares/fetchNewLineOaOrders.middleware'
import homeMiddleware from '@/middlewares/home.middleware'
import orderMiddleware from '@/middlewares/order.middleware'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/Index'),
    meta: { layout: 'no-sidebar-layout' }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home'),
    beforeEnter: homeMiddleware
  },
  {
    path: '/documents',
    name: 'DocumentList',
    component: () => import('@/views/DocumentList')
  },
  {
    path: '/line-official-account',
    component: () => import('@/views/LineOfficialAccount'),
    children: [
      {
        path: '/',
        name: 'LineOfficialAccountChoose',
        component: () => import('@/views/LineOfficialAccount/Choose')
      }
    ]
  },
  {
    path: '/line-official-account/create',
    name: 'LineOfficialAccountCreate',
    component: () => import('@/views/LineOfficialAccount/Create')
  },
  {
    path: '/line-official-account/create-old',
    name: 'LineOfficialAccountCreateOld',
    component: () => import('@/views/LineOfficialAccount/Create/Old')
  },
  {
    path: '/orders',
    name: 'OrderList',
    component: () => import('@/views/Order/index')
  },
  {
    path: '/orders/success',
    name: 'OrderSuccess',
    component: () => import('@/views/Order/Success')
  },
  {
    path: '/orders/summary',
    name: 'OrderSummary',
    component: () => import('@/views/Order/Summary')
  },
  {
    path: '/orders/create/:productType',
    name: 'OrderCreate',
    component: () => import('@/views/Order/CreateEdit'),
    props: true
  },
  {
    path: '/orders/edit/:productType/:id',
    name: 'OrderEdit',
    component: () => import('@/views/Order/CreateEdit'),
    props: true,
    meta: { isEdit: true }
  },
  {
    path: '/orders/:id',
    name: 'OrderDetail',
    component: () => import('@/views/Order/Detail'),
    props: true
  },
  {
    path: '/upload-slip',
    name: 'UploadSlip',
    component: () => import('@/views/UploadSlip/index')
  },
  {
    path: '/upload-slip/success',
    name: 'UploadSlipSuccess',
    component: () => import('@/views/UploadSlip/Success')
  },
  {
    path: '/upload-slip/checkout',
    name: 'Checkout',
    component: () => import('@/views/UploadSlip/Checkout')
  },
  {
    path: '/kpayment-gateway/callback',
    name: 'KPaymentGatewayCallback',
    component: () => import('@/views/KPaymentGateway/Callback')
  },
  {
    path: '/upload-slip/:orderId',
    name: 'UploadSlipByOrderId',
    component: () => import('@/views/UploadSlip/index')
  },
  {
    path: '/upload-slip/:orderId/:payment',
    name: 'UploadSlipByOrderIdWithPayment',
    component: () => import('@/views/UploadSlip/index')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile/index'),
    beforeEnter: fetchCustomerTypesMiddleware
  },
  {
    path: '/profile/edit',
    name: 'ProfileEdit',
    component: () => import('@/views/Profile/Edit'),
    beforeEnter: fetchCustomerTypesMiddleware
  },
  {
    path: '/privilege',
    name: 'Privilege',
    component: () => import('@/views/Privilege')
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    component: () => import('@/views/ContactUs')
  },
  {
    path: '/manual',
    name: 'Manual',
    component: () => import('@/views/Manual')
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/PDPA/PrivacyPolicy.vue'),
    meta: { layout: 'no-sidebar-layout' }
  },
  {
    path: '/term-and-conditions',
    name: 'TermAndConditions',
    component: () => import('@/views/PDPA/TermAndConditions.vue'),
    meta: { layout: 'no-sidebar-layout' }
  },
  {
    path: '/cookie-policy',
    name: 'CookiePolicy',
    component: () => import('@/views/PDPA/CookiePolicy.vue'),
    meta: { layout: 'no-sidebar-layout' }
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/404')
  },
  {
    path: '*',
    redirect: 'NotFound'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: configuration.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes
})

function skipIndex(middleware) {
  return (to, from, next) => (to.name === 'Index' ? next() : middleware(to, from, next))
}

router.beforeEach(affiliateMiddleware)

router.beforeEach(liffMiddleware)

router.beforeEach(skipIndex(fetchProfileMiddleware))

router.beforeEach(skipIndex(fetchSystemConfigMiddleware))

router.beforeEach(skipIndex(fetchNewLineOaOrdersMiddleware))

router.beforeEach(skipIndex(orderMiddleware))

export default router
